import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=3abc70ce&scoped=true&"
import script from "./student-detail.vue?vue&type=script&lang=js&"
export * from "./student-detail.vue?vue&type=script&lang=js&"
import style0 from "./student-detail.vue?vue&type=style&index=0&id=3abc70ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc70ce",
  null
  
)

export default component.exports